import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  consumptionDefaultState,
  consumptionFilterState,
  hasSelectedConsumptionFilterSelector,
  selectedConsumptionFilterLabelSelector,
  selectedConsumptionFilterSelector,
} from '@/states/filters/fuel-consumption.state';

export function useFuelConsumptionFilter() {
  const [consumptionFilterDefault, setConsumptionFilterDefault] =
    useRecoilState(consumptionDefaultState);
  const [consumptionFilter, setConsumptionFilter] = useRecoilState(
    consumptionFilterState
  );
  const selectedConsumptionFilter = useRecoilValue(
    selectedConsumptionFilterSelector
  );
  const setSelectedConsumptionFilter = useSetRecoilState(
    selectedConsumptionFilterSelector
  );
  const selectedConsumptionFilterLabel = useRecoilValue(
    selectedConsumptionFilterLabelSelector
  );
  const hasSelectedConsumptionFilter = useRecoilValue(
    hasSelectedConsumptionFilterSelector
  );
  const resetConsumptionFilter = () => {
    const defaultRange = { min: 0, max: 0 };

    setSelectedConsumptionFilter(defaultRange);
    setConsumptionFilter(defaultRange);
  };

  return {
    consumptionFilterDefault,
    setConsumptionFilterDefault,
    consumptionFilter,
    setConsumptionFilter,
    setSelectedConsumptionFilter,
    selectedConsumptionFilterLabel,
    hasSelectedConsumptionFilter,
    selectedConsumptionFilter,
    resetConsumptionFilter,
  };
}
